const CREATED = "Created";
const ASSIGNED = "Assigned";
const FAILED = "Failed";
const CLOSED = "Closed";

module.exports = {
    CREATED,
    ASSIGNED,
    FAILED,
    CLOSED
};
